<template>
  <div class="intro-cont" data-app>

    <div class="title">중소기업 취업자, 소득세 감면대상자 확인</div>
    <div class="explain mt24">
      이 페이지는 국세청의 <a target="_blank" href="https://www.nts.go.kr/news/news_05.asp?minfoKey=MINF5320080211205338&mbsinfoKey=MBS20181128143154017&type=V">「청년 중소기업 취업자 소득세 감면」 세법 개정 안내</a>의 내용을 토대로 만들어졌습니다.
    </div>
    <div class="explain mt12">
      법이 개정되면 연령은 15 ~ 29세 에서 15 ~ 34세로 확대 되었으며 감면율도 70%에서 90%로 확대되었네요.
    </div>
    <div class="flex mt24">
      <date-selector
          class="date"
          hint="생년월일"
          @emitDate="d => birthDate = d"
      ></date-selector>
      <date-selector
          class="date"
          hint="취업일"
          @emitDate="d => employmentDate = d"
      ></date-selector>
    </div>
    <div class="flex">
      <date-selector
          class="date"
          hint="입대일"
          @emitDate="d => armyEntranceDate = d"
      ></date-selector>
      <date-selector
          class="date"
          hint="전역일"
          @emitDate="d => armyExitDate = d"
      ></date-selector>
    </div>
    <div class="row flex">
      <div class="head">중소기업 취업한 날 연령</div>
      <div :class="getEmploymentStyle">{{getEmploymentDate | dateFormat}}</div>
    </div>
    <div class="row flex">
      <div>병역근무기간</div>
      <div :class="getArmyStyle">{{getMilitaryTerm | dateFormat}}</div>
    </div>
    <div class="row flex">
      <div class="head">병역근무기간 차감 후 연령</div>
      <div :class="getResultStyle">{{getResult | dateFormat}}</div>
    </div>
    <div class="row flex">
      <div class="head">대상여부</div>
      <div :class="getPossibleStyle">{{isPossible}}</div>
    </div>
    <!--<desc-cont></desc-cont>-->
  </div>
</template>

<script>
  import DateSelector from './date-selector.vue';
  import DescCont from './desc-cont.vue';
  let moment = require('moment');

  export default {
    components: {
      DateSelector,
      DescCont
    },
    data () {
      return {
        birthDate: '',
        employmentDate: '',
        armyEntranceDate: '',
        armyExitDate: ''
      }
    },
    computed: {
      getEmploymentStyle () {
        return typeof this.getEmploymentDate !== 'object' ? 'error' : 'success';
      },
      getArmyStyle () {
        return typeof this.getMilitaryTerm !== 'object' ? 'error' : 'success';
      },
      getResultStyle () {
        return typeof this.getResult !== 'object' ? 'error' : 'success';
      },
      getPossibleStyle () {
        return this.isPossible !== '가능' ? 'error' : 'success';
      },
      getEmploymentDate () {
        if (!this.birthDate) return '생년월일을 입력해주세요';
        if (!this.employmentDate) return '취업일을 입력해주세요';
        return this.diff(this.birthDate, this.employmentDate);
      },
      getMilitaryTerm () {
        if (!this.armyEntranceDate) return '입대일을 입력해주세요';
        if (!this.armyExitDate) return '전역을 입력해주세요';
        return this.diff(this.armyEntranceDate, this.armyExitDate);
      },
      getResult () {
        if (!this.birthDate) return '생년월일을 입력해주세요';
        if (!this.employmentDate) return '취업일을 입력해주세요';
        let all = this.diff(this.birthDate, this.employmentDate);
        if (!this.armyEntranceDate && !this.armyExitDate) return all;
        if (!this.armyEntranceDate) return '입대일을 입력해주세요';
        if (!this.armyExitDate) return '전역을 입력해주세요';
        let partial = this.diff(this.armyEntranceDate, this.armyExitDate);
        if (!all || ! partial) return;
        return all.subtract(partial);
      },
      isPossible () {
        if (typeof this.getResult != 'object') return this.getResult;
        return this.getResult.years() < 35 ? '가능' : '불가능';
      }
    },
    mounted () {
    },
    filters: {
      dateFormat: function (d) {
        if (typeof d != 'object') return d;
        let yy = d.years();
        let mm = d.months();
        let dd = d.days();
        return `${yy}년${mm}개월${dd}일`
      }
    },
    methods: {
      diff (d1, d2) {
        if (!d1 || !d2) return '';
        let src = moment(d1);
        let dst = moment(d2);
        if (src >= dst) return '';
        return moment.duration(dst.diff(src));
      }
    }
  }
</script>

<style lang="scss" scoped>
  .intro-cont {
    max-width: 800px;
    margin: 0 auto;

    @media all and (max-width: 800px) {
      padding: 20px;
    }
    @media all and (min-width: 801px) {
      padding: 40px;
    }
    .title {
      text-align: center;
      margin-bottom: 12px;
      font-size: 42px;
      white-space: pre-wrap;
    }
    .explain {
      font-size: 14px;
      color: #333333;
      line-height: 1.7;
    }
    .mt12 { margin-top: 12px; }
    .mt24 { margin-top: 24px; }
    .flex {
      display: flex;
    }
    .date {
      flex: 1;
      margin-left: 12px;
    }
    .row {
      padding: 4px;
      div:nth-child(1) {
        flex: 2;
        text-align: left;
      }
      div:nth-child(2) {
        flex: 1;
        text-align: center;
      }
      .error {
        color: #f8412d;
      }
      .success {
        color: #333;
        font-size: 18px;
      }
    }
  }
</style>
